import React from 'react'
import PropTypes from 'prop-types'

/**
 * 改行やURLを含むテキストに適切なタグを付加する
 */
export default function LongText (props) {
  const { text } = props

  const urlReg = /https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+/g

  return text.split('\n').map((line, i) => {
    const blocks = []
    let result = null
    let startIndex = 0
    while ((result = urlReg.exec(line))) {
      const str = line.substring(startIndex, result.index)
      const url = result[0]
      startIndex = urlReg.lastIndex
      blocks.push({ str: str, url: url })
    }
    if (startIndex === 0) {
      return (
        <div key={`line${i}`}>
          <span>{line}</span>
          <br />
        </div>
      )
    } else {
      return (
        <div key={`line${i}`}>
          {blocks.map((block, j) => (
            <span key={`block${i}-${j}`}>
              {block.str}<a href={block.url} target='_blank' rel='noreferrer' onClick={(e) => e.stopPropagation()}>{block.url}</a>
            </span>
          ))}
          <br />
        </div>
      )
    }
  })
}

LongText.propTypes = {
  text: PropTypes.string
}
